export default __webpack_public_path__ + "static/media/(88).4cd95595.jpg";